/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enum for different preset options. Preset logic is implemented in FE
 */
export enum ApiExportRangeFilterOptionPreset {
    /**
     * Time span of last 30 days
     */
    Last30Days = 0,
    /**
     * Time span of last month
     */
    LastMonth = 1,
    /**
     * Time span of current month
     */
    CurrentMonth = 2,
}
